import React from 'react'
import Widget from '../../Widget'
import WidgetLoader from './WidgetLoader'
import WidgetFooter from './WidgetFooter'
import AccountSelect from './AccountSelect'
import { WidgetProvider } from './WidgetContext'
import WidgetTitle from '../WidgetTitle'

const StkWidget: React.FC = () => {
  return (
    <WidgetProvider>
      <Widget
        widgetTitle={<WidgetTitle title="Buckets and Boosters" />}
        widgetAriaLabel="Buckets and Boosters"
        widgetBody={<WidgetLoader />}
        header={<AccountSelect />}
        footer={<WidgetFooter />}
        dataTestId="stk-widget"
      />
    </WidgetProvider>
  )
}

export default StkWidget
